module.exports = __webpack_public_path__ + "img/201609-2.b9b810b6.jpg";